export default __webpack_public_path__ + "static/homebg-a6f5aec95ea3610eb777b72656bdf09c.jpg";